import { useMemo } from 'react';
import { defaultAreaDataset, defaultBarDataset, defaultColors, defaultLineDataset } from '../constants';

function useDeviceTimeSeriesLabels({ data }) {
  return useMemo(() => data.map((datum) => new Date(datum.timestamp).getTime()), [data]);
}

function useDeviceTimeSeriesDatasets({ data, datasets }) {
  return useMemo(() => datasets.map((dataset, index) => toChartDataset(dataset, data, index)), [data, datasets]);
}

function toChartDataset(dataset, data, index) {
  const { key, type, label, xAxis, yAxis, disabled } = dataset;

  if (disabled) {
    return null;
  }

  const base = {
    label,
    xAxisID: xAxis,
    yAxisID: yAxis,
    data: data.map((datum) => datum[key])
  };

  switch (type) {
    case 'area':
      return toAreaDataset(base, index);
    case 'bar':
      return toBarDataset(base, index);
    case 'line':
    default:
      return toLineDataset(base, index);
  }
}

function toLineDataset(dataset, index) {
  return {
    ...defaultLineDataset,
    ...dataset,
    borderColor: defaultColors[index],
    pointBackgroundColor: defaultColors[index]
  };
}

function toBarDataset(dataset, index) {
  return {
    ...defaultBarDataset,
    ...dataset,
    backgroundColor: defaultColors[index]
  };
}

function toAreaDataset(dataset, index) {
  return {
    ...defaultAreaDataset,
    ...dataset,
    borderColor: defaultColors[index],
    pointBackgroundColor: defaultColors[index]
  };
}

export { useDeviceTimeSeriesLabels, useDeviceTimeSeriesDatasets };
